import {Component, OnInit} from '@angular/core';
import {Constant} from '../../../global/util/Constant';
import {FormBuilder, Validators} from '@angular/forms';
import {UanatacaService} from '../../../user/service/uanataca.service';
import {Document} from '../../../user/model/Document';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentService} from '../../../user/service/document.service';
import {GeolocationIofesign} from '../../../user/model/GeolocationIofesign';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {GeolocationService} from '../../../user/service/geolocation.service';
import {AlertMessage} from '../../../global/util/AlertMessage';
import {IconType} from '../../../global/util/iconType';
import {TranslateService} from '@ngx-translate/core';
import HttpStatusCode from '../../../global/util/HttpStatusCode';

@Component({
    selector: 'app-remote-signing-credential',
    templateUrl: './remote-signing-credential.component.html',
    styleUrls: ['./remote-signing-credential.component.css']
})
export class RemoteSigningCredentialComponent implements OnInit {
    public signCompleted: boolean;
    public signatureForm: any;
    public signBoxDataSelected: any;
    public certificateDueDate: any;
    public uanatacasignboxdatas: any;
    private personId: number;
    public loading: boolean;
    private readonly DEFAULT_COUNTRY = 168;
    public document: any;
    public person: any;
    public countries: any[] = [];
    public viewPassword: boolean;
    public viewPin: boolean;
    public readonly PASSWORD = 1;
    public readonly PIN = 2;
    private geolocation: GeolocationIofesign;
    private longitude = null;
    private latitude = null;
    private accuracy = null;
    private hashIdentifier: string;
    public alertType: any;
    public icon: any;
    public messageAlert: string;
    public showMsg = false;

    constructor(private formBuilder: FormBuilder,
                private route: Router,
                private activatedRoute: ActivatedRoute,
                private documentService: DocumentService,
                public translate: TranslateService,
                private geolocationService: GeolocationService,
                private uanatacaService: UanatacaService) {
        this.receiveParams();
        this.createForm();
    }

    ngOnInit(): void {
        if (!this.document) {
            this.navigatePrincipalUrl();
        }
        this.personId = this.person.id;
        this.getListCountry();
    }

    public createForm() {
        this.signatureForm = this.formBuilder.group(
            {
                username: ['', Validators.required],
                password: ['', Validators.required],
                pin: ['', Validators.compose([
                        Validators.required,
                        Validators.minLength(6)
                    ]
                )],
                country: ['', Validators.required],
                reason: ['']
            });
    }

    public receiveParams() {
        this.activatedRoute.params.subscribe(params => {
            this.hashIdentifier = params.hashIdentifier;
            this.personId = +params.personId;
        });
        this.document = history.state.document;
        this.person = history.state.person;
    }

    public search(data: any) {
        if (data.target.value !== this.signatureForm.get('username').value) {
            this.certificateDueDate = '';
        }
        this.uanatacasignboxdatas = [];
        const user = data.target.value;
        if (user.length > 3) {
            this.uanatacaService.search(this.personId, user).subscribe((next: any) => {
                if (next._embedded) {
                    this.uanatacasignboxdatas = next._embedded.uanatacasignboxdata;
                }
            });
        }
    }

    public onSignboxDataChanged() {
        const listElement = this.signatureForm.get('username').value.split('-');
        const username = listElement[Constant.ZERO_INDEX].trim();
        this.signBoxDataSelected = this.uanatacasignboxdatas.find(value => value.user === username);
        if (this.signBoxDataSelected) {
            this.signatureForm.get('username').setValue(this.signBoxDataSelected.user);
            this.signatureForm.get('reason').setValue(this.signBoxDataSelected.reason);
            this.certificateDueDate = this.signBoxDataSelected.certificateDueDate;
        }
    }

    public isInvalidControl(ctrlName: string) {
        return this.signatureForm.get(ctrlName).invalid && this.signatureForm.get(ctrlName).touched;
    }

    public hasCertificateDueDate(certificateDueDate) {
        if (certificateDueDate) {
            return true;
        } else {
            return false;
        }
    }


    isCertificateDueDateCorrect(certificateDueDateCorrect: any) {
        if (certificateDueDateCorrect) {
            return new Date(certificateDueDateCorrect) > new Date();
        }
    }

    public getListCountry() {
        this.loading = true;
        this.showMsg = false;
        const url = Constant.ROOT_API_V1.concat('/public/countries?uuid=', this.document._more.uuid)
            .concat('&personId=')
            .concat(String(this.personId));
        this.uanatacaService.post(url, null).subscribe(value => {
            this.loading = false;
            this.countries = value;
            this.signatureForm.get('country').setValue(this.DEFAULT_COUNTRY);
        }, () => {
            this.loading = false;
            this.signCompleted = false;
            this.showMessage(AlertMessage.DANGER, IconType.DANGER, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
        });
    }

    public toggleFieldTextType(passwordType: number) {
        if (this.PASSWORD === passwordType) {
            this.viewPassword = !this.viewPassword;
        } else if (this.PIN === passwordType) {
            this.viewPin = !this.viewPin;
        }
    }

    signDocument() {
        this.showMsg = false;
        if (this.signatureForm.invalid) {
            Object.values(this.signatureForm.controls).forEach(control => {
                // @ts-ignore
                control.markAllAsTouched();
            });
            return;
        }
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/uanataca/public/people/', String(this.personId))
            .concat('/username/', String(this.signatureForm.get('username').value))
            .concat('/password/', String(this.signatureForm.get('password').value))
            .concat('/pin/', String(this.signatureForm.get('pin').value))
            .concat('/documents/sign')
            .concat('?uuid=', this.document._more.uuid)
            .concat('&countryId=')
            .concat(String(this.signatureForm.get('country').value))
            .concat('&reason=')
            .concat(String(this.signatureForm.get('reason').value));
        this.uanatacaService.post(url, [this.document]).subscribe(value => {
            if (value) {
                this.loading = false;
                this.showMsg = false;
                this.checkStatusOne2OneForSignatureRemote(this.document);
            }
        }, error => {
            this.loading = false;
            this.signCompleted = false;
            this.showMessage(AlertMessage.DANGER, IconType.DANGER, error.error.message);
            if (error.error.status === HttpStatusCode.NOT_FOUND) {
                this.navigatePrincipalUrl();
            }
        });
    }

    /**
     * Evalua el estado de firma remota.
     */
    public checkStatusOne2OneForSignatureRemote(document: Document) {
        this.showMsg = false;
        const urlOne2One = Constant.ROOT_API_V1.concat('/public/uanataca/signs/one2one/status')
            .concat('?personId=')
            .concat(String(this.personId))
            .concat('&documentId=')
            .concat(String(document.id));
        this.loading = true;
        const interval = setInterval(() => {
            this.documentService.get(urlOne2One).subscribe((next: any) => {
                if (next.completed === Constant.FINISHED) {
                    this.signCompleted = true;
                    const documents = [];
                    documents.push(document);
                    this.loading = false;
                    this.saveGeolocation(documents, this.personId, 'Firma remota');
                    clearInterval(interval);
                    this.navigateDocumentSigned();
                }
            }, error => {
                this.loading = false;
                this.showMessage(AlertMessage.DANGER, IconType.DANGER, error.error.message);
                clearInterval(interval);
            });
        }, 2000);
    }

    private saveGeolocation(documents: Document[], personId: number, signatureType: string) {
        this.showMsg = false;
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < documents.length; index++) {
            const date = new Date(Date.now());
            const documentId = documents[index].id;
            this.geolocation = this.setValueGeolocation(documentId, personId);
            this.geolocation.signatureType = signatureType;
            this.geolocation.longTime = Date.now().toString();
            this.geolocation.timeStamp = date.toString();
            this.geolocation.timeZone = this.getGMT(date);
            this.geolocation.identification = null;
            this.geolocationService.save(this.geolocation).subscribe(resp => {

            }, error => {
                this.showMsg = true;
                this.showMessage(AlertMessage.DANGER, IconType.DANGER, 'No se pudo guardar su ubicación.');
            });
        }
    }

    private setValueGeolocation(documentId: number, personId: number) {
        this.geolocation = new GeolocationIofesign();
        this.geolocation.latitude = String(this.latitude);
        this.geolocation.longitude = String(this.longitude);
        this.geolocation.accuracy = String(this.accuracy);
        this.geolocation.documentId = documentId;
        this.geolocation.personId = personId;
        this.geolocation.ip = LocalStorage.getIpAddress();
        return this.geolocation;
    }

    private getGMT(date: Date) {
        return date.toTimeString().split(' ')[1];
    }

    navigateDocumentSigned() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'document-signed');
    }

    navigatePrincipalUrl() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'sign');
    }

    goBack() {
        this.hasConfigRubric ? this.navigateNextScreen(this.hashIdentifier, this.personId, 'add-or-draw-rubric') :
            this.navigateNextScreen(this.hashIdentifier, this.personId, 'viewer');
    }

    /**
     * Este método recibe paramatros para navegar entre pantallas.
     * @param hashIdentifier :
     * @param personId :
     * @param nameUrl :
     * @private
     */
    private navigateNextScreen(hashIdentifier: any, personId: any, nameUrl: any) {
        this.route.navigate(['document/' + hashIdentifier + '/people/' + personId + '/' + nameUrl + '/'], {
            state: {
                document: this.document,
                person: this.person
            }
        }).then();
    }

    showMessage(alert: string, icon: string, message: any) {
        this.showMsg = true;
        this.alertType = alert;
        this.messageAlert = message;
        this.icon = icon;
    }

    get hasConfigRubric(): boolean {
        if (this.document !== undefined) {
            return this.document._more.hasRubricSettings;
        }
    }

    get hasDragRubric(): boolean {
        return this.document._more.dragRubric;
    }
}
